
import { useVezgoState } from '@/providers/vezgo';
import { VezgoAccount, VezgoConnection, VezgoCallbackResult } from '@/providers/vezgo/types';
import { ConnectionProcessingState } from '@/providers/vezgo/constants';

/**
 * Combined hook for Vezgo connection state management
 * Provides a unified interface for components to access Vezgo state
 */
export function useVezgoConnectState() {
  const vezgoState = useVezgoState();
  
  return {
    // Connection status
    isConnected: vezgoState.isConnected,
    isLoading: vezgoState.isLoading,
    error: vezgoState.error,
    
    // Provider info
    connection: vezgoState.connection,
    provider: vezgoState.provider,
    providerDisplayName: vezgoState.providerDisplayName,
    
    // Account data
    accounts: vezgoState.accounts || [],
    
    // Processing state
    isProcessing: vezgoState.isProcessing,
    processingState: vezgoState.processingState,
    processingProgress: vezgoState.processingProgress,
    
    // Refresh state
    isRefreshing: vezgoState.isRefreshInProgress,
    
    // Callback handling
    callbackResult: vezgoState.callbackResult,
    
    // Added to fix TypeScript error - expose these functions from vezgoState
    setProcessingState: vezgoState.setProcessingState,
  };
}

// Export types used by components
export interface VezgoConnectState {
  isConnected: boolean;
  isLoading: boolean;
  error: Error | null;
  connection: VezgoConnection | null;
  provider: string;
  providerDisplayName: string;
  accounts: VezgoAccount[];
  isProcessing: boolean;
  processingState: ConnectionProcessingState;
  processingProgress: number;
  isRefreshing: boolean;
  callbackResult: VezgoCallbackResult | null;
  setProcessingState: (state: ConnectionProcessingState) => void;
}
